import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import type { DeliveryPoint } from '../../../../types/gcs/deliveryPoint';
import { getMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { Text } from '../../../../components/general/Text';

interface DeliveryPointMarkerProps {
  deliveryPoint: DeliveryPoint;
}

export const DeliveryPointMarker = ({ deliveryPoint }: DeliveryPointMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Marker
        longitude={deliveryPoint.location.lng}
        latitude={deliveryPoint.location.lat}
        anchor='center'
        style={{ zIndex: getMapElementZIndex(MapElement.DELIVERY_POINT) }}
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <circle cx='20' cy='20' r='19' fill='var(--map-element-on-ground)' stroke='white' strokeWidth='2' />
          <path
            d='M20 23C16.8299 23 14.0108 24.5306 12.216 26.906C11.8297 27.4172 11.6365 27.6728 11.6429 28.0183C11.6477 28.2852 11.8153 28.6219 12.0253 28.7867C12.2972 29 12.6738 29 13.4272 29H26.5727C27.3261 29 27.7028 29 27.9746 28.7867C28.1846 28.6219 28.3522 28.2852 28.3571 28.0183C28.3634 27.6728 28.1703 27.4172 27.784 26.906C25.9892 24.5306 23.17 23 20 23Z'
            fill='white'
          />
          <path
            d='M20 20C22.4853 20 24.5 17.9853 24.5 15.5C24.5 13.0147 22.4853 11 20 11C17.5147 11 15.5 13.0147 15.5 15.5C15.5 17.9853 17.5147 20 20 20Z'
            fill='white'
          />
        </svg>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={deliveryPoint.location.lng}
          latitude={deliveryPoint.location.lat}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>{deliveryPoint.name}</Text>
          </div>
        </Popup>
      )}
    </>
  );
};
